
export default {
  name: 'BaseProfileProductImages',
  props: {
    images: {
      type: Array,
      default: null,
    },
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: 'Изображения',
    },
  },
  data() {
    return {
      isShowLoadMoreButton: false,
      isShowFullViewButton: false,
      elementsCount: 2,
    }
  },
  computed: {
    croppedImages() {
      return this.images.slice(0, this.elementsCount)
    },
  },
  mounted() {
    this.isShowLoadMoreButton = this.images?.length > this.elementsCount
  },
  methods: {
    showMore() {
      this.elementsCount = this.images.length
      this.isShowLoadMoreButton = false
    },
  },
}
